import BackButton from "../components/common/BackButton";
import Container from "../components/common/Container";
import MadeIn from "../components/common/MadeIn";

function Support() {
  return (
    <Container>
      <BackButton to="/profile" />
      <MadeIn />
    </Container>
  );
}

export default Support;
